<template>
  <button 
    v-if="hasPromotions" 
    @click.stop="$emit('open')"
    class="promo-badge"
    type="button"
  >
    🔥 {{ $t("mylist.deals.seeDeals") }}
  </button>
</template>

<script>
export default {
  name: 'PromotionsBadge',
  props: {
    promotions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasPromotions() {
      return this.promotions && this.promotions.length > 0;
    },
  },
};
</script>

<style scoped>
.promo-badge {
  margin-right: auto;
  color: #ea580c;
  font-weight: 600;
  cursor: pointer;
  background: #fff7ed;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.promo-badge:hover {
  background: #ffedd5;
  color: #c2410c;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(234, 88, 12, 0.15);
}

.promo-badge svg {
  transition: transform 0.2s ease;
}

.promo-badge:hover svg {
  transform: translateY(2px);
}

.promo-badge:active {
  transform: translateY(0);
}

@media screen and (max-width: 767px) {
  .promo-badge {
    padding: 2px 2px;
    font-size: 0.75rem;
  }
}
</style>
